import { type Entity } from '@backstage/catalog-model';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { ENTITY_PULSE_TAB_PATH } from './entity-pulse-link';

const EXCLUDED_KINDS = new Set(['group', 'user']);

const isPulseAvailable = (entity: Entity) =>
  !EXCLUDED_KINDS.has(entity.kind.toLowerCase());

export { ENTITY_PULSE_TAB_PATH } from './entity-pulse-link';
export { buildEntityPulseHref, CHECK_QUERY_PARAM } from './entity-pulse-link';

export const entityContentPulse: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'pulse',
    params: {
      path: ENTITY_PULSE_TAB_PATH,
      title: 'Pulse',
      filter: isPulseAvailable,
      loader: async () =>
        import('./entity-content').then(m => <m.EntityContent />),
    },
  });
